module.exports = __webpack_public_path__ + "static/avril-prep-a1425e734b08d3991ae272c52376c6b0.gif";